import React from 'react'
import { ReactComponent as Close } from '../../../assets/icons/close.svg'
import { ReactComponent as OutlinedInfo } from '../../../assets/icons/outlined-info.svg'

import Button from './Button.js'

const InfoModal = ({
  modalClassName = '',
  contentClassName = '',
  isOpen,
  onOpen,
  onClose,
  children,
}) => {
  const closeButton = (
    <Button className="cd-modal-btn" onClick={onClose} datatestid="cd-modal-close">
      <Close width={20} height={20} />
    </Button>
  )

  const openButton = (
    <Button className="cd-modal-btn" onClick={onOpen} datatestid="cd-modal-open">
      <OutlinedInfo width={20} height={20} />
    </Button>
  )

  return (
    <div className={`cd-modal ${modalClassName}`}>
      <div
        data-testid="cd-modal-container"
        className={`cd-modal-container ${isOpen ? 'cd-modal-active' : ''}`}
      >
        {isOpen ? (
          <>
            {closeButton}
            <div className={`content ${contentClassName}`}>{children}</div>
          </>
        ) : (
          openButton
        )}
      </div>
    </div>
  )
}

export default InfoModal
